import React from 'react';
import PropTypes from 'prop-types';
import { NavSideBarListWithSectionsWithRedux } from './NavSideBarList';

class StaticBuilderNavSideBar extends React.PureComponent {
  render() {
    return (
      <div id="well1" className="well well-no-padding">
        <ul id="WizardNav" className={`nav nav-list ${this.props.additionalClassNamesForNavList}`} >
          <NavSideBarListWithSectionsWithRedux
            {...this.props}
            showRequestSignature={this.props.showRequestSignature}
          />
        </ul>
      </div>
    );
  }
}

StaticBuilderNavSideBar.defaultProps = {
  showRequestSignature: false,
  additionalClassNamesForNavList: '',
};

StaticBuilderNavSideBar.propTypes = {
  additionalClassNamesForNavList: PropTypes.string,
  showRequestSignature: PropTypes.bool,
};

export default StaticBuilderNavSideBar;




// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderNavSideBar.jsx